module.exports = __webpack_public_path__ + "img/dat07.fc62536e.jpg";